import * as components from './components'

export default [
  {
    path: '/user/setup',
    component: components.UserSetup,
    name: 'userSetup',
    props: true
  },
  {
    path: '/dashboard',
    component: components.Dashboard,
    name: 'dashboard',
    props: true,
    meta: {
      title: 'Pragya: Dashboard'
    }
  },
  {
    path: '/courses',
    component: components.Courses,
    name: 'courses',
    props: true,
    meta: {
      title: 'Pragya: Courses'
    }
  },
  {
    path: '/course/:uuid/dashboard',
    component: components.CourseDashboard,
    name: 'courseDashboard',
    props: true,
    meta: {
      title: 'Pragya: Course Dashboard'
    }
  },
  {
    path: '/course/:uuid/detail',
    component: components.CourseDetail,
    name: 'courseDetail',
    props: true,
    meta: {
      title: 'Pragya: Course Detail'
    }
  },
  {
    path: '/course/:uuid/content',
    component: components.CourseTOC,
    name: 'courseTOC',
    props: true,
    meta: {
      title: 'Pragya: Course TOC'
    }
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/about',
    component: components.EntityDetail,
    name: 'entityDetail',
    props: true
  },
  {
    path: '/course/:uuid/result/:entityType/:entityUuid',
    component: components.EntityResult,
    name: 'entityResult',
    props: true
  },
  {
    path: '/dashboard/learner',
    component: components.LearnerDashboard,
    name: 'learnerDashboard',
    props: true
  },
  {
    path: '/dashboard/modern',
    component: components.ModernDashboard,
    name: 'modernDashboard',
    props: true
  },
  {
    path: '/dashboard/event',
    component: components.CalendarEventList,
    name: 'calendarEventList',
    props: true
  },
  {
    path: '/channel/:uuid',
    component: components.Channel,
    name: 'channel',
    props: true
  },
  {
    path: '/learner/:uuid/profile',
    component: components.LearnerProfile,
    name: 'learnerProfile',
    props: true
  },
  {
    path: '/learner/programs',
    component: components.LearnerProgramList,
    name: 'learnerProgramList',
    props: true
  },
  {
    path: '/purchases',
    component: components.Purchases,
    name: 'purchases',
    props: true
  },
  {
    path: '/wallet',
    component: components.Wallet,
    name: 'wallet',
    props: true
  },
  {
    path: '/institution/switch',
    component: components.InstitutionSwitch,
    name: 'institutionSwitch',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/dashboard/routes.js